import {
  Application as ApplicationDto,
  Group as GroupDto,
  GroupMembershipTypeEnum,
} from '@electricjs/core_entity-client';

export const simpleGroup: GroupDto = {
  id: 'simple-group-id',
  name: 'Test Group Name',
  created_at: '2023-05-22',
  updated_at: '2023-05-22',
  import_enabled: true,
  applications_count: 2,
  employees_count: 1,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const simpleGroupApplicationList: ApplicationDto[] = [
  {
    id: 'aaeea7bc-054e-11ee-be56-0242ac120002',
    name: 'Zoom',
    slug: 'zoom',
    icon: '',
    url: 'https://zoom.us',
    integration_availability: 'not_available',
    category: 'productivity_collaboration',
  },
  {
    id: '13e20646-1322-4493-8417-8993e77332cc',
    name: 'Teams',
    slug: 'teams',
    icon: '',
    url: 'https://teams.microsoft.com',
    integration_availability: 'not_available',
    category: 'productivity_collaboration',
  },
];

export const dynamicGroup: GroupDto = {
  id: 'c1f6b8e2-1a2b-4c3d-9e4f-5a6b7c8d9e0f',
  name: 'Dynamic Engineering',
  employees_count: 6,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Dynamic,
};

export const hrisSyncedGroup: GroupDto = {
  id: 'd2e7c9f3-2b3c-5d4e-af5a-6b7c8d9e0f1a',
  name: 'HR Synced Sales',
  employees_count: 3,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
  hris_group_integration: {
    source_id: 'hris-source-sales',
    hris_integration_id: 'hris-integration-id',
  },
};

// Reparenting fixtures: three unparented groups so the EditGroupModal confirmation
// copy can be exercised via the UI without any existing hierarchy getting in the way.
// - Add "Child Group" as a subgroup of "Parent Group" to reproduce the reported bug
//   (message must name Child Group, not Parent Group).
// - Set "Parent Group"'s own Parent group to "Grandparent Group" *in the same save*
//   to exercise the combined hasParentChanged + subgroup-added message.
export const grandparentGroup: GroupDto = {
  id: 'mock-grandparent-group-id',
  name: 'Grandparent Group',
  employees_count: 2,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
};

export const parentGroup: GroupDto = {
  id: 'mock-parent-group-id',
  name: 'Parent Group',
  employees_count: 3,
  applications_count: 2,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
};

export const childGroup: GroupDto = {
  id: 'mock-child-group-id',
  name: 'Child Group',
  employees_count: 5,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
};

// Hierarchical fixtures for exercising arbitrarily-deep group trees (e.g.
// the Configure Applications step's groups multi-select) — a 5-level-deep
// chain (Engineering > Backend > Platform > Platform Core) plus several
// level-2/3 siblings, all rooted under "All Employees".
export const allEmployeesGroup: GroupDto = {
  id: 'mock-group-all-employees',
  name: 'All Employees',
  employees_count: 48,
  applications_count: 3,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
};

export const engineeringGroup: GroupDto = {
  id: 'mock-group-engineering',
  name: 'Engineering',
  employees_count: 12,
  applications_count: 2,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: allEmployeesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const designGroup: GroupDto = {
  id: 'mock-group-design',
  name: 'Design',
  employees_count: 6,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: allEmployeesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const productGroup: GroupDto = {
  id: 'mock-group-product',
  name: 'Product',
  employees_count: 5,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: allEmployeesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const marketingGroup: GroupDto = {
  id: 'mock-group-marketing',
  name: 'Marketing',
  employees_count: 8,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: allEmployeesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const salesGroup: GroupDto = {
  id: 'mock-group-sales',
  name: 'Sales',
  employees_count: 15,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: allEmployeesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const backendGroup: GroupDto = {
  id: 'mock-group-backend',
  name: 'Backend',
  employees_count: 7,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: engineeringGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const frontendGroup: GroupDto = {
  id: 'mock-group-frontend',
  name: 'Frontend',
  employees_count: 5,
  applications_count: 1,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: engineeringGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const productAnalyticsGroup: GroupDto = {
  id: 'mock-group-product-analytics',
  name: 'Product Analytics',
  employees_count: 2,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: productGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const salesWestGroup: GroupDto = {
  id: 'mock-group-sales-west',
  name: 'Sales West',
  employees_count: 8,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: salesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const salesEastGroup: GroupDto = {
  id: 'mock-group-sales-east',
  name: 'Sales East',
  employees_count: 7,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: salesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const platformGroup: GroupDto = {
  id: 'mock-group-platform',
  name: 'Platform',
  employees_count: 4,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: backendGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

// 5 levels deep: All Employees > Engineering > Backend > Platform > Platform Core
export const platformCoreGroup: GroupDto = {
  id: 'mock-group-platform-core',
  name: 'Platform Core',
  employees_count: 2,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: platformGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

// Dynamic + nested, for previewing the "Dynamic" chip alongside a deep
// ancestor-path breadcrumb in the Groups table.
export const platformOnCallGroup: GroupDto = {
  id: 'mock-group-platform-on-call',
  name: 'Platform On-Call',
  employees_count: 3,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: platformGroup.id,
  membership_type: GroupMembershipTypeEnum.Dynamic,
};

// Deliberately long name, for previewing text wrapping in the groups
// dropdown.
export const salesEnterpriseAccountsGroup: GroupDto = {
  id: 'mock-group-sales-enterprise-accounts',
  name: 'Enterprise Key Accounts, Strategic Partnerships & Renewals Management',
  employees_count: 6,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  parent_group_id: salesGroup.id,
  membership_type: GroupMembershipTypeEnum.Static,
};

export const hierarchicalOrganizationGroups: GroupDto[] = [
  allEmployeesGroup,
  engineeringGroup,
  designGroup,
  productGroup,
  marketingGroup,
  salesGroup,
  backendGroup,
  frontendGroup,
  productAnalyticsGroup,
  salesWestGroup,
  salesEastGroup,
  platformGroup,
  platformCoreGroup,
  platformOnCallGroup,
  salesEnterpriseAccountsGroup,
];

const makeUnusedFixtureGroup = (
  overrides: Partial<GroupDto> & Pick<GroupDto, 'id' | 'name'>
): GroupDto => ({
  employees_count: 0,
  applications_count: 0,
  import_enabled: true,
  created_at: '2023-09-08T13:54:17.026537',
  updated_at: '2023-09-08T13:54:17.026537',
  membership_type: GroupMembershipTypeEnum.Static,
  ...overrides,
});

// Fixtures for the "Hide unused groups" filter (a group is unused when it has
// neither employees nor applications). Toggling the filter should:
// - hide: Unused Standalone, Dynamic No Matches, Empty Subgroup, and the whole
//   Retired Department chain
// - keep: Apps Only Standalone (apps but no employees) and Empty Parent (unused
//   itself, but kept visible because its subgroup Used Subgroup is in use)
// Combined with "Show dynamic groups only", only dynamic groups in use remain.
const emptyParentGroup = makeUnusedFixtureGroup({
  id: 'mock-group-empty-parent',
  name: 'Empty Parent',
});
const retiredDepartmentGroup = makeUnusedFixtureGroup({
  id: 'mock-group-retired-department',
  name: 'Retired Department',
});
const retiredTeamGroup = makeUnusedFixtureGroup({
  id: 'mock-group-retired-team',
  name: 'Retired Team',
  parent_group_id: retiredDepartmentGroup.id,
});

export const unusedGroupFixtures: GroupDto[] = [
  makeUnusedFixtureGroup({
    id: 'mock-group-unused-standalone',
    name: 'Unused Standalone',
  }),
  makeUnusedFixtureGroup({
    id: 'mock-group-apps-only-standalone',
    name: 'Apps Only Standalone',
    applications_count: 2,
  }),
  makeUnusedFixtureGroup({
    id: 'mock-group-dynamic-no-matches',
    name: 'Dynamic No Matches',
    membership_type: GroupMembershipTypeEnum.Dynamic,
  }),
  emptyParentGroup,
  makeUnusedFixtureGroup({
    id: 'mock-group-used-subgroup',
    name: 'Used Subgroup',
    parent_group_id: emptyParentGroup.id,
    employees_count: 4,
    applications_count: 1,
  }),
  makeUnusedFixtureGroup({
    id: 'mock-group-empty-subgroup',
    name: 'Empty Subgroup',
    parent_group_id: emptyParentGroup.id,
  }),
  // Fully unused 3-level chain: every group in it is hidden by the filter.
  retiredDepartmentGroup,
  retiredTeamGroup,
  makeUnusedFixtureGroup({
    id: 'mock-group-retired-team-alumni',
    name: 'Retired Team Alumni',
    parent_group_id: retiredTeamGroup.id,
  }),
];

export const employeeGroups: GroupDto[] = [
  {
    id: '5b7c6edc-f6b4-416c-af0a-a1e41f57ea48',
    name: 'Lexi Inherit',
    employees_count: 4,
    applications_count: 0,
    import_enabled: true,
    created_at: '2023-09-08T13:54:17.026537',
    updated_at: '2023-09-08T13:54:17.026537',
    membership_type: GroupMembershipTypeEnum.Static,
  },
  {
    id: 'a4283a80-ec82-4015-b712-0d63cabe3c8f',
    name: 'test-Great-grandparent',
    employees_count: 1,
    applications_count: 0,
    import_enabled: true,
    created_at: '2023-09-06T14:19:47.196628',
    updated_at: '2023-09-08T14:09:37.677815',
    membership_type: GroupMembershipTypeEnum.Static,
  },
  {
    id: '89f59e26-c007-4f1d-94d1-60a4e64c390b',
    name: 'test-grandparent1',
    employees_count: 2,
    applications_count: 0,
    import_enabled: true,
    created_at: '2023-09-01T19:04:28.212193',
    updated_at: '2023-09-09T01:16:12.464124',
    parent_group_id: 'a4283a80-ec82-4015-b712-0d63cabe3c8f',
    membership_type: GroupMembershipTypeEnum.Static,
  },
  dynamicGroup,
  hrisSyncedGroup,
];
